import $ from "jquery";
import Seed from "DMS/Seed/All";
/**
 * Lister les sites en fonction
 * @param {string} secteur code du secteur
 * @param {string} site code du site
 */
export default function loadSite(secteur, site) {
    if (typeof site == "undefined") {
        secteur = "_ALL_";
        site = "_ALL_";
    }
    Seed.Ajax.Post({
        url: root + "../../EPortail/source/template/dynMenuSite.php",
        data: "codeclient=" + codeclient
            + "&secteur=" + secteur
            + "&site=" + site,
        async: true,
        success: (xml) => $('#sites').replaceWith(xml)
    });
}
//# sourceMappingURL=ePortail_dynMenu.js.map